import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AwardTypeDataTable from '../../../../components/datatables/postSecondary/AwardTypeDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface AwardTypeListProps {
}

interface AwardTypeListState {
}

class AwardTypeListPage extends React.Component<AwardTypeListProps & RouteComponentProps<RouteObject>, AwardTypeListState> {
  constructor(props: AwardTypeListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="Award Type" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.awardTypeList()} />

        <Card >
          <AwardTypeDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(AwardTypeListPage);
